<template>
	<div class="menu-banners-ctn">
		<base-menu-banner v-for="banner in banners" :key="banner.eventId" :text="banner.text" class="menu-banner-item" @close="$store.commit('notifications/removeLiveState', banner.eventId)"/>
	</div>
</template>

<script>
import i18nMixin from '@/mixins/i18n.mixin'
import { WRITTEN_NOTIFICATION, INMEDIATA_NOTIFICATION, CHAT_NOTIFICATION, CALL_NOTIFICATION, NEW_CHAT_MESSAGE } from '@/constants/signalRCommands'
import BaseMenuBanner from '@/components/base/ui/BaseMenuBanner'

const I18N_FILE = 'public/views/patient/menu-banners'

export default {
	name: 'menu-banners',
	components: {
		BaseMenuBanner
	},
	mixins: [i18nMixin(I18N_FILE)],
	data () {
		return {
			allBanners: [
				{
					eventId: INMEDIATA_NOTIFICATION,
					text: this.$t('patient.menu-banners.queue-instant-video')
				},
				{
					eventId: WRITTEN_NOTIFICATION,
					text: this.$t('patient.menu-banners.queue-written')
				},
				{
					eventId: CHAT_NOTIFICATION,
					text: this.$t('patient.menu-banners.queue-chat')
				},
				{
					eventId: CALL_NOTIFICATION,
					text: this.$t('patient.menu-banners.queue-call')
				},
				{
					eventId: NEW_CHAT_MESSAGE,
					text: this.$t('patient.menu-banners.new-chat-messages')
				}
			]
		}
	},
	computed: {
		banners () {
			const liveStates = this.$store.state.notifications.liveStates
			if (liveStates.length) {
				return this.allBanners.filter(banner => liveStates.includes(banner.eventId))
			} else {
				return []
			}
		}
	},
	methods: {
		getLiveStates () {
			this.$store.dispatch('notifications/get')
		}
	},
	created () {
		if (!this.$store.state.notifications.retrievedLiveStates) {
			this.getLiveStates()
		}
	},
	watch: {
		'$store.state.notifications.lastNotification' (notification) {
			if (this.allBanners.map(banner => banner.eventId).includes(notification.id) && (!this.$store.state.notifications.liveStates || !this.$store.state.notifications.liveStates.includes(notification.id))) {
				this.$store.commit('notifications/addLiveState', notification.id)
			}

			if (notification.id === NEW_CHAT_MESSAGE) {
				this.$store.commit('notifications/updateSummary')
			}
		}
	}
}
</script>

<style lang="scss">
.menu-banners-ctn {
	@include desktop {
		p {
			margin: 0 auto;
		}
		
		margin-bottom: 2rem;
		margin-top: -2rem;
		@include container-padding;
		z-index: 0;
    position: relative;
	}

	@include media(mobile, tablets) {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		text-align: center;
		margin-bottom: 2rem;
	}
}

.menu-banner-item:not(:last-child) {
    margin-bottom: 1rem;
}
</style>


// WEBPACK FOOTER //
// src/components/webapp/patient/MenuBanners.vue